export const set = (state, action) => {
  return {
    ...state,
    loginModalContext: action.payload,
  }
}
